import React from 'react';

import { LogoLoader } from 'components/Common/LogoLoader/LogoLoader';
import Unauthorized from 'components/Common/UnauthorizedPage';
import useAccessibleModules from 'hooks/useAccessibleModules';

function LazyRender(Component: React.ComponentType<any>, props?: Record<string, any>, moduleId: number | null = null) {
    const Wrapper = () => {
        const userModules = useAccessibleModules();

        if (moduleId == null) {
            return (
                <React.Suspense fallback={<LogoLoader size='large' />}>
                    <Component {...props} />
                </React.Suspense>
            );
        }

        if (userModules === null || userModules.length == 0) {
            return <LogoLoader size='large' />;
        }

        const hasAccess = userModules.includes(moduleId);

        if (!hasAccess) {
            return <Unauthorized />;
        }

        return (
            <React.Suspense fallback={<LogoLoader size='large' />}>
                <Component {...props} />
            </React.Suspense>
        );
    };

    return <Wrapper />;
}

export default LazyRender;
